import React, { useEffect } from 'react'
import { AbstructVar } from '../../general/general-component/abstruct-component/AbstructVar'
import Table2 from '../../table/Table2'
import SectionTopOfTable from '../../general/general-component/section-top-of-table/SectionTopOfTable'
import { useSelectorCustom } from '../../general/general-component/abstruct-component/useSelectorCustom'
import InnerLoader from '../../general/inner-loader/InnerLoader'
import { AbstructLang } from '../../general/general-component/abstruct-component/AbstructLang'
import { ColumnCreative_Work_Requests } from '../../general/general-component/columns-component/ColumnCreative_Work_Requests'
import { loadCreativeWork } from '../../../store/Actions/ActionCreativeWork'
import { VariableCreativeWorkRequests } from './VariableCreativeWorkRequests'
import FilterScriptsReqests from './FilterScriptsReqests'
import { UsePermissions, hasPermissions } from '../../general/general-component/abstruct-component/UsePermissions'
import CheckPermissions from '../../general/general-component/check-permissions'

const Creative_Work_Requests = () => {
    const { permissionss, loadingMainPermission } = UsePermissions();
    const project_requests = hasPermissions([{ name: "project-requests" }], permissionss)
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { translate } = AbstructLang()
    const { creativeWork, loadingcreativeWork } = useSelectorCustom()
    const { state, handleEdit, handleEvaluationDetails } = VariableCreativeWorkRequests()

    useEffect(() => {
        dispatch(loadCreativeWork())
    }, []);

    const { columns } = ColumnCreative_Work_Requests(translate, handleEdit, handleEvaluationDetails, langLocal)
    return (
        <>
            <CheckPermissions array={project_requests} loadingMainPermission={loadingMainPermission} >
                <main>
                    <FilterScriptsReqests translate={translate} />
                    <div className="div_table margin_main shadow_main" dir={langLocal == "ar" ? "rtl" : "ltr"} >
                        <SectionTopOfTable langLocal={langLocal} title={translate('creative_work_requests')} />
                        {
                            loadingcreativeWork == false ? (
                                <div style={{ overflowX: 'auto' }} ><Table2 col={columns} roo={creativeWork} /></div>
                            ) : <InnerLoader />
                        }
                    </div>
                </main>
            </CheckPermissions>


        </>
    )
}

export default Creative_Work_Requests
